import React from 'react'

export interface DescriptionListItem {
  label: string
  value: React.ReactNode
  formatter?: (value: any) => string
}

export interface DescriptionListSection {
  title: string
  subtitle?: string
  items: DescriptionListItem[]
}

interface DescriptionListProps {
  sections: DescriptionListSection[]
  /** Number of columns to display sections in on large screens (default: 1) */
  columns?: 1 | 2
}

export default function DescriptionList({ sections, columns = 1 }: DescriptionListProps) {
  const containerClass = columns === 2
    ? 'grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-10'
    : 'space-y-10'

  return (
    <div className={containerClass}>
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          <div className="px-4 sm:px-0">
            <h3 className="text-base font-semibold text-purple-950">{section.title}</h3>
            {section.subtitle && (
              <p className="mt-1 max-w-2xl text-sm text-gray-500">{section.subtitle}</p>
            )}
          </div>
          <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
              {section.items.map((item, itemIndex) => {
                let displayValue: React.ReactNode = item.value

                if (item.formatter && item.value !== undefined && item.value !== null) {
                  displayValue = item.formatter(item.value)
                } else if (item.value === null || item.value === undefined) {
                  displayValue = '-'
                } else if (typeof item.value === 'boolean') {
                  displayValue = item.value ? 'Yes' : 'No'
                } else if (typeof item.value !== 'object') {
                  displayValue = String(item.value)
                }

                return (
                  <div key={itemIndex} className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                    <dt className="text-sm font-medium text-gray-900">{item.label}</dt>
                    <dd className="mt-1 text-sm text-gray-700 sm:col-span-2 sm:mt-0">
                      {displayValue}
                    </dd>
                  </div>
                )
              })}
            </dl>
          </div>
        </div>
      ))}
    </div>
  )
}